// Authentication storage keys
export const ACCESS_TOKEN_KEY = 'token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const ACCESS_TOKEN_EXP_KEY = 'tokenExpiresAt';

/**
 * Inactivity logout timeout - user will be logged out after this period of inactivity
 * Default: 1 hour (3,600,000 ms)
 */
export const INACTIVITY_LOGOUT_TIMEOUT = 60 * 60 * 1000; // 1 hour

/**
 * Activity tracking interval - how often to check for user activity
 * Default: 1 minute (60,000 ms)
 */
export const ACTIVITY_CHECK_INTERVAL = 60 * 1000; // 1 minute

/**
 * Token refresh buffer time - refresh token this many milliseconds before expiry
 * Currently not used (refresh happens on-demand), but available for future proactive refresh
 * Default: 5 minutes (300,000 ms)
 */
export const TOKEN_REFRESH_BUFFER_TIME = 5 * 60 * 1000; // 5 minutes

// House storage keys
export const SELECTED_HOUSE_ID_KEY = 'selected_house_id';
/** Stores the public_id (UUID) of the last selected house — used as redirect fallback */
export const SELECTED_HOUSE_PUBLIC_ID_KEY = 'selected_house_public_id';
